import { render, staticRenderFns } from "./EpsonFiscalReceiptCoupon.vue?vue&type=template&id=21953f31&scoped=true&"
import script from "./EpsonFiscalReceiptCoupon.vue?vue&type=script&lang=js&"
export * from "./EpsonFiscalReceiptCoupon.vue?vue&type=script&lang=js&"
import style0 from "./EpsonFiscalReceiptCoupon.vue?vue&type=style&index=0&id=21953f31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21953f31",
  null
  
)

export default component.exports